/**
 * arTableSelection
 *
 * The selection shape and the two operations on it that reach outside the
 * ArTable tree — `ArWorkflowMenu`, `ArTableControls` and `ArBulkActionsMenu`
 * all read a table's selection through `formStore.getTableSlot` and must not
 * import the component-local state module to do it. Structurally compatible
 * with `SelectionState` in `createArTableState`, which owns the real proxy.
 *
 * `clearSelection` is the only way a selection ends, so it is where `scope`
 * returns to `'visible'`: an escalation to the whole table must not survive the
 * ticks that justified it, and page changes already route through here.
 */

import type { ArRowId } from '#types/System.Artifacts.types';

export type ArTableSelectionState = {
  selectedRows: Record<ArRowId, unknown>;
  selectedRowIds: ArRowId[];
  selectedRowIndexById: Record<ArRowId, number>;
  selectedCount: number;
  lastClickedRowId: ArRowId | null;
  scope: 'visible' | 'all';
};

export function getSelectedRowIds(selection: ArTableSelectionState): ArRowId[] {
  return [...selection.selectedRowIds];
}

export function clearSelection(selection: ArTableSelectionState): void {
  for (const rowId of selection.selectedRowIds) {
    delete selection.selectedRows[rowId];
    delete selection.selectedRowIndexById[rowId];
  }
  selection.selectedRowIds.length = 0;
  selection.selectedCount = 0;
  selection.lastClickedRowId = null;
  selection.scope = 'visible';
}
